import React from "react";

const TabNavigation = ({ activeTab, onTabChange }) => {
  return (
    <div className="flex border-b border-gray-200">
      <button
        className={`flex-1 py-3 px-1 text-center font-medium text-sm ${
          activeTab === "login"
            ? "text-red-600 border-b-2 border-red-600"
            : "text-gray-500 hover:text-gray-700"
        }`}
        onClick={() => onTabChange("login")}
      >
        Login
      </button>
      <button
        className={`flex-1 py-3 px-1 text-center font-medium text-sm ${
          activeTab === "signup"
            ? "text-red-600 border-b-2 border-red-600"
            : "text-gray-500 hover:text-gray-700"
        }`}
        onClick={() => onTabChange("signup")}
      >
        Sign Up
      </button>
    </div>
  );
};

export default TabNavigation;
